const MediaQueries = {
    xs: "(max-width: 576px)",
    sm: "(min-width: 576px)",
    md: "(min-width: 768px) and (max-width: 991px)",
    lg: "(min-width: 992px) and (max-width: 1199px)",
    xl: "(min-width: 1200px)",
};

export default MediaQueries;